(() => {
  const script = document.currentScript;
  const translationsUrl = script?.dataset.translationsUrl;
  const locale = document.documentElement.lang;
  const rootsSelector = 'section[id^="DcEmsResults-"], section[id^="DcEmsActivations-"], section[id^="DcEmsDual-"], section[id^="DcMedical-"]';

  const finish = () => {
    document.documentElement.classList.remove('dc-ems-shorts-is-localizing');
    document.dispatchEvent(new CustomEvent('dc:ems-shorts-new-localized', { detail: { locale } }));
  };

  if (!translationsUrl || locale === 'es') {
    finish();
    return;
  }

  fetch(translationsUrl)
    .then((response) => {
      if (!response.ok) throw new Error(`Translation file returned ${response.status}`);
      return response.json();
    })
    .then(({ sources, translations }) => {
      const values = translations[locale];
      if (!values || values.length !== sources.length) return;

      const dictionary = new Map(sources.map((source, index) => [source, values[index]]));
      const partialSources = [...dictionary.keys()].sort((a, b) => b.length - a.length);
      const ignoredTags = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'SVG']);
      const translatedAttributes = ['aria-label', 'title', 'alt'];

      const translateTextNode = (node) => {
        if (!node.parentElement || ignoredTags.has(node.parentElement.tagName)) return;
        const source = node.nodeValue.replace(/\s+/g, ' ').trim();
        const translated = dictionary.get(source);
        if (!translated || translated === source) return;
        const leadingSpace = node.nodeValue.match(/^\s*/)?.[0] || '';
        const trailingSpace = node.nodeValue.match(/\s*$/)?.[0] || '';
        node.nodeValue = `${leadingSpace}${translated}${trailingSpace}`;
      };

      const translateAttribute = (element, attribute) => {
        const source = element.getAttribute(attribute);
        if (!source) return;
        const normalized = source.replace(/\s+/g, ' ').trim();
        const direct = dictionary.get(normalized);
        if (direct) {
          element.setAttribute(attribute, direct);
          return;
        }
        let translated = source;
        partialSources.forEach((part) => {
          if (translated.includes(part)) translated = translated.split(part).join(dictionary.get(part));
        });
        if (translated !== source) element.setAttribute(attribute, translated);
      };

      document.querySelectorAll(rootsSelector).forEach((root) => {
        if (locale === 'ar') root.setAttribute('dir', 'rtl');
        const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
        let node;
        translatedAttributes.forEach((attribute) => translateAttribute(root, attribute));
        while ((node = walker.nextNode())) {
          if (node.nodeType === Node.TEXT_NODE) translateTextNode(node);
          else translatedAttributes.forEach((attribute) => translateAttribute(node, attribute));
        }
      });
    })
    .catch((error) => console.warn('Dolce Catene EMS localization:', error))
    .finally(finish);
})();
